import * as React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from "react-router-dom";
import { isMobile, isIE } from "react-device-detect";
// import PaymentComplete from "components/Common/Mobile/Payment/PaymentComplete";
// import IntroduceMobile from "components/Travel/Mobile/Introduce";
// import SimpleCheckMobile from "components/Travel/Mobile/SimpleCheck.container";
import SubscriptionMobile from "components/Travel/Mobile/Subscription";
// import TravelMobile from "components/Travel/Mobile/Travel.container";
// import CompleteMobile from "components/Travel/Mobile/Complete";
// import IntroducePC from "components/Travel/PC/Introduce";
// import TravelPC from "components/Travel/PC/Travel.container";
// import CompletePC from "components/Travel/PC/Complete";
import SubscriptionPC from "components/Travel/PC/Subscription";
import Loading from "components/Travel/Shared/loading";
import {
  checkParamsMRT,
  getUserId,
  getParameterByName
} from "components/Travel/function";
// import NoMatch from "components/NoMatch";
if (isMobile) {
  checkParamsMRT();
}

// USER KEY
getUserId();

const platform = getParameterByName("platform", window.location.search);
const mrtPlatform = platform ? `&platform=${platform}` : "";
if (window.location.pathname !== "/travel/mrt/subscription") {
  window.location.href = `${process.env.REACT_APP_BOMAPP_PARTNER_URL}${mrtPlatform}`;
}

const Routes: React.FC = () => (
  <div className={`${isMobile ? "mobile" : "pc"} ${isIE ? "ie" : ""}`}>
    <Router>
      {isMobile ? (
        <>
          <Switch>
            <Route exact path="/" component={Loading} />
            <Route
              path="/travel/mrt/subscription"
              component={SubscriptionMobile}
            />
            <Redirect from="*" to="/" />
          </Switch>
        </>
      ) : (
        <>
          <Switch>
            <Route exact path="/" component={Loading} />
            <Route path="/travel/mrt/subscription" component={SubscriptionPC} />
            <Redirect from="*" to="/" />
          </Switch>
        </>
      )}
    </Router>
  </div>
);

export default Routes;
